// extracted by mini-css-extract-plugin
export var customA = "Button-module--custom-a--7568a";
export var customButton = "Button-module--custom-button--50b88";
export var gradientAnimation = "Button-module--gradientAnimation--836f0";